import {NftMetadata, NftsApi, Token} from "@devour/client";
import getConfig from "@/utils/getConfig";
import {useQuery} from "@tanstack/react-query";

async function fetchNftMetadata(nftOwnershipId: string, fullToken: Token): Promise<NftMetadata> {
    return await new NftsApi(getConfig(fullToken)).getNftMetadata({
        id: nftOwnershipId,
    });
}

function getNftMetadataQuery(nftOwnershipId: string, fullToken: Token) {
    return {
        queryKey: [
            "nft-metadata",
            nftOwnershipId,
            fullToken?.id ?? "unauthenticated",
        ],
        queryFn: () => fetchNftMetadata(nftOwnershipId, fullToken),
        keepPreviousData: true,
        staleTime: 30 * 60000,
        refetchOnWindowFocus: false,
        enabled: Boolean(nftOwnershipId && fullToken),
    } as const;
}

export function useGetNftMetadata(nftOwnershipId: string, fullToken: Token) {
    return useQuery(getNftMetadataQuery(nftOwnershipId, fullToken));
}